import { render } from "./StoryUpdateForm.vue?vue&type=template&id=6487b0d4"
import script from "./StoryUpdateForm.vue?vue&type=script&lang=js"
export * from "./StoryUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__